import React from 'react';
import { useGetUnreadCountQuery } from 'src/api/redux';
const NotificationIndicator = () => {
  const { data: unreadCount } = useGetUnreadCountQuery();
  const count = unreadCount?.count ?? 0;
  if (count === 0) return null;
  return (
    <div
      role="status"
      aria-label={`${count} unread notification${count !== 1 ? 's' : ''}`}
      data-testid="notification-indicator"
      className="absolute -top-1 -right-1 w-4 h-4 rounded-full flex items-center justify-center text-[10px] font-bold bg-red-500 text-white"
    >
      {count}
    </div>
  );
};

export default NotificationIndicator;
